export default __webpack_public_path__ + "04fee94a3962bc9d23d3e81d88a4892e.gif";